import script from "./SettingOdds.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingOdds.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__